import React from 'react';
import Navbar from '../Shared/Navbar/Navbar';

const Help = () => {
    return (
        <div>
            <Navbar />
            <div style={{ padding: '150px' }} className='container'>
                <h1 className='banner-title text-center'>Help US!! 😛</h1>
            </div>
        </div>
    );
};

export default Help;